/* Import app components */

/* Dashboard */
const dropdown = () => import("./components/dropdown/dropdown.vue"),
	card = () => import("./components/card/card.vue"),
	dropdownSimple = () => import("./components/dropdown/dropdownSimple.vue"),
	calendar = () => import("./components/calendar/calendar.vue"),
	tooltip = () => import("./components/tooltip/tooltip.vue"),
	number = () => import("./components/numberComponent/number.vue"),
	loader = () => import("./components/loader/Loader.vue"),
	weight = () => import("./components/weightComponent/weight.vue"),

	/* App components init */

	SharedComponents = {
		install (Vue) {
			Vue.component("dropdown", dropdown);
			Vue.component("card", card);
			Vue.component("dropdownSimple", dropdownSimple);
			Vue.component("number", number);
			Vue.component("calendar", calendar);
			Vue.component("tooltip", tooltip);
			Vue.component("loader", loader);
			Vue.component("weight", weight);
		}
	};

export default SharedComponents;
